import { render } from "./SpannungsabfallDrehstrom.vue?vue&type=template&id=9142c61a"
import script from "./SpannungsabfallDrehstrom.vue?vue&type=script&lang=js"
export * from "./SpannungsabfallDrehstrom.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__